// Globals
import { ReactNode } from 'react';

// Components
import { Tooltip } from '@/ui';
import {
  StyledContentBlock,
  StyledLabel,
  StyledTooltipIcon,
  StyledTooltipWrap,
  StyledValue,
} from './AdditionalInfoContentBlockStyles';
import { COLORS } from '@/theme';

interface AdditionalInfoContentBlockProps {
  label: string;
  value?: ReactNode;
  tooltip?: string;
}

const AdditionalInfoContentBlock = ({ label, value, tooltip }: AdditionalInfoContentBlockProps) => {
  return value ? (
    <StyledContentBlock>
      <StyledTooltipWrap>
        <StyledLabel>{label}</StyledLabel>
        {tooltip && (
          <Tooltip title={tooltip} color={COLORS.SOFT_GRAY} placement="topRight">
            <StyledTooltipIcon />
          </Tooltip>
        )}
      </StyledTooltipWrap>
      <StyledValue>{value}</StyledValue>
    </StyledContentBlock>
  ) : null;
};

export default AdditionalInfoContentBlock;
